import styled from "@emotion/styled";
import { useEffect, useRef, useState } from "react";


  const throttle = (callback: () => void, delay: number) => {
    let isThrottled = false;
    let args: any;
    let context: any;
    if(isThrottled) return;
    isThrottled = true;
    callback.apply(context, args);
    setTimeout(() => {
      isThrottled = false;
    }, delay);
  };


const useFadeInOnVisible = (ref: React.RefObject<HTMLElement>) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isFadedIn, setIsFadedIn] = useState(false);


  const handleScroll = () => throttle(() => {
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect();
      const isVisible = rect.top < window.innerHeight - 30;
      setIsVisible(isVisible);
    }
  }, 1000);





  useEffect(() => {
    if (isVisible) {
      setIsFadedIn(true);
    }
  }, [isVisible]);

  useEffect(() => {
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isVisible]);

  return isFadedIn;
};

interface FadeInContentProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

const FadeInWrapper = styled.div`
  opacity: 0;
  transform: translateY(20px);
  transition: all 1s linear;
  &.fade-in {
    opacity: 1;
    transform: translateY(0);
  }
`;

export function FadeInContent({ children, ...props }: FadeInContentProps) {
  const ref = useRef(null);
  const isFadedIn = useFadeInOnVisible(ref);

  return (
    <FadeInWrapper ref={ref} className={isFadedIn ? "fade-in" : ""} {...props}>
      {children}
    </FadeInWrapper>
  );
}
